import React, { Component } from 'react';
import Formulario from './SeleccionarPeriodoNominaForm';


class SeleccionarPeriodo extends Component{

    componentDidMount = () => {
        const { periodosList } = this.props;
        periodosList();
    }
    render(){
        const { periodoL, datos, listarPeriodos, periodos_nomina } = this.props;
        return(
           
            <Formulario
                periodoL={periodoL}
                datos={datos}
                listarPeriodos = {listarPeriodos}
                periodos_nomina = {periodos_nomina}
            />
           
        );
    } 
}

export default SeleccionarPeriodo;